import { render, staticRenderFns } from "./create-integration-dialog.vue?vue&type=template&id=b973a59e&scoped=true&"
import script from "./create-integration-dialog.vue?vue&type=script&lang=ts&"
export * from "./create-integration-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./create-integration-dialog.vue?vue&type=style&index=0&id=b973a59e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b973a59e",
  null
  
)

export default component.exports